import { Message } from '@/types';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];

export const isImagePath = (filepath: string): boolean =>
  IMAGE_EXTENSIONS.some(ext => filepath.toLowerCase().endsWith(ext));

// imageAttachmentsOf returns the unique image attachment paths on a message,
// drawn from both the model-visible `attachments` and the UI-only
// `userAttachments` (e.g. per-tool-call browser screenshots).
export function imageAttachmentsOf(
  message: Pick<Message, 'attachments' | 'userAttachments'> | null | undefined
): string[] {
  if (!message) return [];
  const all = [
    ...(Array.isArray(message.attachments) ? message.attachments : []),
    ...(Array.isArray(message.userAttachments) ? message.userAttachments : []),
  ].filter((x): x is string => typeof x === 'string' && isImagePath(x));
  return [...new Set(all)];
}
